import { IconCircleX } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import './SelectedFiltersBar.scss';

interface Props {
    selectedFilters: Partial<Record<string, { value: string; label: string }[]>>;
    setSelectedFilters: React.Dispatch<React.SetStateAction<any>>;
}

const CATEGORY_LABELS: Record<string, string> = {
    types: 'Type',
    formats: 'Format',
};

const SelectedFiltersBar = ({ selectedFilters, setSelectedFilters }: Props) => (
    <div
        className="SelectedFiltersBar__container"
    >
        {Object.entries(selectedFilters).map(([category, filters]) => filters?.map((filter: any, idx: number) => (
            <div
                key={`${category}-${filter.value || filter}-${filter.id}`}
                className="SelectedFiltersBar__filter-pill"
            >
                <span className="SelectedFiltersBar__label">
                    {`${CATEGORY_LABELS[category] || category}: `}
                    <strong>{filter.label || filter}</strong>
                </span>
                <button
                    type="button"
                    onClick={() => {
                        setSelectedFilters((prev: any) => ({
                            ...prev,
                            [category]: prev[category]?.filter((f: any) => (f.value || f) !== (filter.value || filter)),
                        }));
                    }}
                    className="btn btn-link p-0 text-white"
                >
                    <NSIcon icon={IconCircleX} className="SelectedFiltersBar__remove-icon" />
                </button>
            </div>
        )))}
    </div>
);

export default SelectedFiltersBar;
